export function Logo({ className = "" }: { className?: string }) {
  return (
    <span className={`logo ${className}`.trim()}>
      <span className="logo__sprinkles" aria-hidden="true">
        <i />
        <i />
        <i />
      </span>
      <span className="logo__word">SprinkleDays</span>
    </span>
  );
}
